import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import { Form, FormikValues, useFormikContext } from "formik";
import moment from "moment";
import { FC, useCallback, useEffect } from "react";
import {
  useFindOneMeetingLazyQuery,
  useGetAllMeetingsLazyQuery,
} from "../../../../../../generated/graphql";
import useAppStore from "../../../../../../states/zustand/appStore";
import { IProps } from "../../../../../../types/EC/ec";
import CreatePageFormFooter from "../../../../../common/Form/CreatePageFormFooter/CreatePageFormFooter";
import FileUploadButton from "../../../../../common/Form/FileUpload/FileUploadButton";
import ProgressSteps from "../../../../../common/ProgressSteps/ProgressSteps";
import { REQUIRED_DOC } from "../../../utils";
import Projects from "../../Projects";
import InputField from "../../../../../common/Form/Input/InputField";
import DropdownWithOther from "../../../../IRB/IRBSubmission/CreateIRBSubmission/StudyDetails/DropdownWithOther";
import { MEETING_TYPE } from "../../../../../../constants";
import { GetAllMeetingsQuery } from "../../../../../../generated/graphql";
import FormDropdownField from "../../../../../common/Form/Dropdown/FormDropdownField";

interface MeetingProps extends IProps {
  id?: string;
}

const ScheduleDetailsForm: FC<MeetingProps> = (props): JSX.Element => {
  const { id, steps, setSteps, stepsInfo } = props;
  const { values, setValues, setFieldValue } = useFormikContext<FormikValues>();
  const { setLoader } = useAppStore();
  const [getMeeting, { data: selectedMeetingData, loading }] =
    useFindOneMeetingLazyQuery();
  const [getAllMeetings, { data }] = useGetAllMeetingsLazyQuery();

  const fetchMeeting = useCallback(async (id: string) => {
    let res = await getMeeting({
      variables: {
        _id: id,
      },
    });

    let data = res.data?.findOneMeeting;

    if (data) {
      let body = {
        ...data,
        selectedMeeting: data?.meetingId,
        meetingType: data?.meetingType,
        meetingId: data?.meetingId,
        meetingDate: moment(data?.meetingDate).format("yyyy-MM-DD"),
        lastSubmissionDate: moment(data?.lastSubmissionDate).format(
          "yyyy-MM-DD"
        ),
        agenda: data?.agenda,
        // mom: data?.mom,
        projects: data?.projects?.map((p) => {
          return {
            _id: {
              label: p._id.title,
              value: p._id._id,
            },
            documents: p.documents.map((d) => ({
              label: d.label,
              required: false,
              url: d.url,
              isEditable: REQUIRED_DOC.includes(d.label) ? false : true,
              isInputOpened: REQUIRED_DOC.includes(d.label) ? false : true,
            })),
          };
        }),
      };
      setValues(body);
    }
  }, []);

  const onDateChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue("meetingDate", e.target.value);
    getAllMeetings({
      variables: {
        meetingType: values.meetingType,
        meetingDate: e.target.value,
        page: 1,
        perPage: 10,
      },
    });
  };

  const onMeetingTypeChange = async (fieldName: string, value: string) => {
    setFieldValue(fieldName, value);
    getAllMeetings({
      variables: {
        meetingType: value,
        meetingDate: values.meetingDate,
        page: 1,
        perPage: 10,
      },
    });
  };

  const onMeetingSelection = async (fieldName: string, value: {label: string, value: string}) => {
    const res = await getMeeting({
      variables: {
        _id: value.value || "",
      },
    });
    setValues({
      ...values,
      _id: value.value,
      agenda: res.data?.findOneMeeting.agenda,
      lastSubmissionDate: res.data?.findOneMeeting.lastSubmissionDate,
      meetingId: res.data?.findOneMeeting.meetingId,
      [fieldName]: value.label,
    });
  };

  useEffect(() => {
    if (id) {
      fetchMeeting(id);
    }
  }, [id]);

  useEffect(() => {
    setLoader(loading);
  }, [loading]);
  return (
    <Form>
      <>
        <Card>
          <CardContent className="pd-x-32 pd-t-32 pd-b-20">
            <Typography className="mg-b-10" variant="h2" component="h2">
              Schedule Details
            </Typography>
            <ProgressSteps stepsInfo={stepsInfo} currentStep={steps} />
            <Divider className={`mg-b-32`} />
            <Grid container className="justify-content-center">
              <Grid item xs={12} md={10} lg={10}>
                <DropdownWithOther
                  options={[MEETING_TYPE.MIEC, MEETING_TYPE.MIRB, MEETING_TYPE.MSMC]}
                  label={"1. Meeting Type"}
                  name={"meetingType"}
                  placeholder={"Short Text"}
                  disabled={false}
                  callBack={onMeetingTypeChange}
                />
                <InputField
                  type="date"
                  label={"2. Meeting Date"}
                  className="mg-b-50"
                  name="meetingDate"
                  placeholder=""
                  value={values.meetingDate}
                  onChange={onDateChange}
                />
                
                <FormDropdownField
                  label={"3. Meeting List"}
                  value={values.selectedMeeting}
                  name={"selectedMeeting"}
                  options={[
                    ...(data?.getAllMeetings.meetings || []).map((x) => ({
                      label: x.meetingId,
                      value: x._id,
                    })),
                  ]}
                  inputHandler={onMeetingSelection}
                  className={`mg-b-10`}
                  // disabled={!!id}
                />
                <Box className="mg-b-50">
                  <label className="form-label mg-b-20">
                    4. Minutes of Meeting (MOM)
                  </label>
                  <FileUploadButton
                    name="mom"
                    label="Upload"
                    className="mg-t-0"
                  />
                </Box>

                <Projects />
              </Grid>
            </Grid>
            <CreatePageFormFooter
              setSteps={setSteps}
              steps={steps}
              stepsInfo={stepsInfo}
            />
          </CardContent>
        </Card>
      </>
    </Form>
  );
};

export default ScheduleDetailsForm;
